import { render } from "./EmployeeList.vue?vue&type=template&id=61558a63&scoped=true"
import script from "./EmployeeList.vue?vue&type=script&lang=js"
export * from "./EmployeeList.vue?vue&type=script&lang=js"

import "./EmployeeList.vue?vue&type=style&index=0&id=61558a63&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61558a63"]])

export default __exports__